import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RightBridgeApiService } from '../../../../services/right-bridge-api.service';
import { ClipboardService } from 'ngx-clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WarnDialogComponent } from '../../../../warn-dialog/warn-dialog.component';

@Component({
  selector: 'app-decrypt-field',
  templateUrl: './decrypt-field.component.html',
  styleUrls: ['./decrypt-field.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
})
export class DecryptFieldComponent {
  @Input() label = '';
  @Input() title = '';
  @Input() value = '';

  private rbs = inject(RightBridgeApiService);
  private clippy = inject(ClipboardService);
  private snacky = inject(MatSnackBar);
  dialog = inject(MatDialog);

  decryptValue(value, title) {
    this.rbs.decryptValue(value).subscribe({
      next: resp => {
        if (resp['resultString']) {
          let dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: title,
              content: `Value: ${resp['resultString']}`,
              confirm: 'Copy to Clipboard',
              cancel: 'Close',
              hideCancel: false,
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 'continue') {
              this.clippy.copy(resp['resultString']);
              this.snacky.open(`Copied to clipboard!`, 'Close', {
                duration: 4000,
              });
            }
            dialogRef = null;
          });
        }
      },
      error: err => {
        console.error('ERROR: ', err);
        this.snacky.open(
          `Oops! Something went wrong. Please try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
      },
    });
  }
}
